import {
  Bot,
  Headset,
  MessagesSquare,
  MessageCircle,
  Ticket,
  BookOpenText,
  Cpu,
  Globe2,
  ShieldCheck,
  Plug,
  Rocket,
  LineChart,
} from "lucide-react";

export const SOLUTIONS = [
  {
    id: "ai-customer-service",
    title: "AI Customer Service",
    desc: "Autonomous agents resolve tickets end-to-end, learning from every conversation to deflect volume and delight customers.",
    icon: Bot,
    tag: "Automation",
  },
  {
    id: "omnichannel",
    title: "Omnichannel Contact Center",
    desc: "Voice, email, social and chat unified into a single intelligent workspace with a shared customer timeline.",
    icon: Headset,
    tag: "Unified",
  },
  {
    id: "ai-chatbot",
    title: "AI Chatbot",
    desc: "Conversational bots that understand intent, answer instantly and hand off to humans with full context.",
    icon: MessagesSquare,
    tag: "Conversational",
  },
  {
    id: "live-chat",
    title: "Live Chat",
    desc: "Real-time messaging with proactive triggers, co-browsing and sub-second response across every device.",
    icon: MessageCircle,
    tag: "Realtime",
  },
  {
    id: "smart-ticketing",
    title: "Smart Ticketing",
    desc: "Auto-triage, prioritize and route tickets with AI so the right agent solves the right issue, faster.",
    icon: Ticket,
    tag: "Workflow",
  },
  {
    id: "knowledge",
    title: "Knowledge Management",
    desc: "A living knowledge base that powers self-service and feeds your AI with always-current answers.",
    icon: BookOpenText,
    tag: "Self-serve",
  },
];

export const REASONS = [
  {
    n: "01",
    title: "AI-Driven Automation",
    desc: "Deflect up to 70% of repetitive requests with agents that reason, act and improve continuously.",
    icon: Cpu,
  },
  {
    n: "02",
    title: "Global SaaS Platform",
    desc: "One platform, deployed across regions, translating and localizing conversations for teams worldwide.",
    icon: Globe2,
  },
  {
    n: "03",
    title: "Secure Cloud Infrastructure",
    desc: "Enterprise-grade encryption, SOC 2 aligned controls and data residency you can trust.",
    icon: ShieldCheck,
  },
  {
    n: "04",
    title: "Easy API Integration",
    desc: "Composable APIs and webhooks connect your CRM, commerce and internal tools in minutes.",
    icon: Plug,
  },
  {
    n: "05",
    title: "Scalable Enterprise Solutions",
    desc: "From startup to Fortune 500, elastic capacity handles millions of conversations without a hiccup.",
    icon: Rocket,
  },
  {
    n: "06",
    title: "Real-Time Analytics",
    desc: "Live dashboards surface CSAT, resolution rates and AI performance the moment they change.",
    icon: LineChart,
  },
];

export const INDUSTRIES = [
  "E-commerce",
  "Financial Services",
  "Healthcare",
  "Education",
  "Technology",
  "Retail",
];

export const STATS = [
  { value: "180+", label: "Countries served" },
  { value: "99.99%", label: "Platform uptime" },
  { value: "70%", label: "Tickets auto-resolved" },
  { value: "4.9/5", label: "Customer rating" },
];

export const IMAGES = {
  dashboard:
    "https://static.prod-images.emergentagent.com/jobs/35a9d59d-838f-47d5-97d5-964ebef1f7b7/images/1cca8b120f6f8bcebeae17fbf2188bf4d8f75f98732e8c5b7fe2c7de67878789.jpeg",
  wave: "https://static.prod-images.emergentagent.com/jobs/35a9d59d-838f-47d5-97d5-964ebef1f7b7/images/d0abc245db1df59a0965839f5283fb2938edbba21278b64182e02314e1f6b087.jpeg",
  orb: "https://static.prod-images.emergentagent.com/jobs/35a9d59d-838f-47d5-97d5-964ebef1f7b7/images/26b68c655921b1c8dffc6b03ee50fb2a20d5d3a94d758f54fed01293cea894c9.jpeg",
  support: "https://images.unsplash.com/photo-1714079761488-e0c9b9ac4138",
  trust: "https://images.unsplash.com/photo-1638262052640-82e94d64664a",
};
